import { z } from "zod";
import { variantSchema } from "./table";
/** The leaderboard (slice 0020): every player, one game, one period, ranked by wins. */
export const leaderboardPeriodSchema = z.enum(["week", "month", "all"]);
/** Everyone, or only the players of the caller's own Discord server (slice 0023). */
export const leaderboardScopeSchema = z.enum(["all", "guild"]);
export const leaderboardEntrySchema = z.object({
    rank: z.number().int().min(1),
    userId: z.string(),
    name: z.string(),
    avatar: z.string().nullable(),
    /** Placement points in the period; may be negative (ADR 0025). */
    points: z.number().int(),
    wins: z.number().int().min(0),
    matches: z.number().int().min(0),
    /** Places gained since the period before; "new" when absent then; null for all time. */
    trend: z.union([z.number().int(), z.literal("new")]).nullable(),
    /** The player hid their name from others (review 0016 decision 92): name empty, no avatar. */
    hidden: z.literal(true).optional(),
});
export const leaderboardSchema = z.object({
    period: leaderboardPeriodSchema,
    scope: leaderboardScopeSchema,
    /** False when the caller has no verified server: the client hides the filter. */
    guildKnown: z.boolean(),
    variant: variantSchema,
    /** When the period turns, for the countdown; null for all time. */
    endsAt: z.number().int().nullable(),
    entries: z.array(leaderboardEntrySchema),
    /** The caller's own row wherever it stands; null before a counted match. */
    you: leaderboardEntrySchema.nullable(),
});
/** One game's current top three per period (review 0014): who wears a rank frame. */
export const podiumsSchema = z.object({
    variant: variantSchema,
    week: z.array(z.string()).max(3),
    month: z.array(z.string()).max(3),
    all: z.array(z.string()).max(3),
});
//# sourceMappingURL=leaderboard.js.map